<template>
    <div id="new-ad">
        <div class="new-ad-wrap">
            <div class="new-ad-pad">
                <div class="new-ad-col">
                    <div class="new-ad-field-wrap">
                        <div class="new-ad-title">Nafn</div>
                        <input class="new-ad-input" type="text" v-model="currentAd.name">
                    </div>
                    <div class="new-ad-field-wrap">
                        <div class="new-ad-title">Linkur</div>
                        <input class="new-ad-input" type="text" v-model="currentAd.url">
                    </div>
                    <div class="new-ad-field-wrap new-ad-date-wrap">
                        <datetime type="datetime" v-model="currentAd.startDate" class="theme-red" input-class="hidden start-date-input" input-id="start-date-input" format="yyyy-MM-dd HH:mm"></datetime>
                        <div class="new-ad-date-button add-paragraph-button" v-on:click="handleStartDateClick()">Byrjunar Dagsetning</div>
                        <div class="new-ad-date-text">{{ displayDate(currentAd.startDate) }}</div>
                    </div>
                    <div class="new-ad-field-wrap new-ad-date-wrap">
                        <datetime type="datetime" v-model="currentAd.endDate" class="theme-red" input-class="hidden end-date-input" input-id="end-date-input" format="yyyy-MM-dd HH:mm"></datetime>
                        <div class="new-ad-date-button add-paragraph-button" v-on:click="handleEndDateClick()">Enda Dagsetning</div>
                        <div class="new-ad-date-text">{{ displayDate(currentAd.endDate) }}</div>
                    </div>
                </div>
                <div class="new-ad-col">
                    <div class="new-ad-title">Tegund</div>
                    <div class="new-ad-type-wrap">
                        <div v-on:click="currentAd.type = 'top'" class="new-ad-type-button" v-bind:class="{'new-ad-type-active': currentAd.type=='top'}">Banner efst</div>
                        <div v-on:click="currentAd.type = 'bottom'" class="new-ad-type-button" v-bind:class="{'new-ad-type-active': currentAd.type=='bottom'}">Banner neðst</div>
                        <div v-on:click="/*currentAd.type = 'wine'*/" class="new-ad-type-button" v-bind:class="{'new-ad-type-active': currentAd.type=='wine'}">Vín</div>
                    </div>

                    <div v-if="currentAd.type" class="new-ad-title">Síða</div>
                    <div v-if="currentAd.type" class="new-ad-page-wrap">
                        <div v-on:click="currentAd.page = 'home'" class="new-ad-type-button" v-bind:class="{'new-ad-type-active': currentAd.page=='home'}">Heim</div>
                        <div v-if="currentAd.type !== 'bottom'" v-on:click="currentAd.page = 'catalog'" class="new-ad-type-button" v-bind:class="{'new-ad-type-active': currentAd.page=='catalog'}">Öll vín</div>
                        <div v-if="currentAd.type !== 'bottom'" v-on:click="currentAd.page = 'wine'" class="new-ad-type-button" v-bind:class="{'new-ad-type-active': currentAd.page=='wine'}">Vín</div>
                        <div v-if="currentAd.type !== 'bottom'" v-on:click="currentAd.page = 'blog'" class="new-ad-type-button" v-bind:class="{'new-ad-type-active': currentAd.page=='blog'}">Greinar</div>
                        <div v-on:click="currentAd.page = 'food'" class="new-ad-type-button" v-bind:class="{'new-ad-type-active': currentAd.page=='food'}">Vín með mat</div>
                        <div v-if="currentAd.type !== 'bottom'" v-on:click="currentAd.page = 'contact'" class="new-ad-type-button" v-bind:class="{'new-ad-type-active': currentAd.page=='contact'}">Hafa samband</div>
                    </div>

                    <div v-if="currentAd.type == 'top' || currentAd.type == 'bottom'" class="new-ad-image-preview-wrap">
                        <div class="new-ad-title">Stór skjár (1150x141)</div>
                        <input type="file" id="banner" accept="image/*" style="display:none" @change="previewImage('banner')">
                        <div id="banner-preview" class="new-ad-image-preview new-ad-image-banner"></div>
                        <div v-on:click="handleImageClick('banner')" class="add-paragraph-button">Velja mynd</div>
                    </div>

                    <div v-if="currentAd.type == 'top' || currentAd.type == 'bottom'" class="new-ad-image-preview-wrap">
                        <div class="new-ad-title">Síma skjár (354x98)</div>
                        <input type="file" id="banner-mobile" accept="image/*" style="display:none" @change="previewImage('banner-mobile')">
                        <div id="banner-mobile-preview" class="new-ad-image-preview new-ad-image-banner-mobile"></div>
                        <div v-on:click="handleImageClick('banner-mobile')" class="add-paragraph-button">Velja mynd</div>
                    </div>

                    <div v-if="currentAd.type == 'wine'" class="new-ad-image-preview-wrap">
                        <div class="new-ad-title">Mynd</div>
                        <input type="file" id="wine-img" accept="image/*" style="display:none" @change="previewImage('wine-img')">
                        <div id="wine-img-preview" class="new-ad-image-preview new-ad-image-wine"></div>
                        <div v-on:click="handleImageClick('wine-img')" class="add-paragraph-button">Velja mynd</div>
                    </div>
                </div>
                
            </div>
            <div class="new-ad-save-wrap">
                <div class="new-ad-save blue-button" v-on:click="finalizeAd(); $emit('finish')" v-bind:class="{'new-ad-save-disabled': !allFieldsFilled()}">Save</div>
            </div>
        </div>
    </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            currentAd: {
                name: "",
                type: "",
                startDate: "",
                endDate: "",
                imageBanner: "",
                imageBannerMobile: "",
                imageCard: "",
                url: "",
                page: "",
            },
        }
    },
    components: {
        datetime: Datetime
    },
    methods: {
        handleImageClick: function(type) {
            if (type == "banner") document.getElementById("banner").click()
            else if (type == "banner-mobile") document.getElementById("banner-mobile").click()
            else document.getElementById("wine-img").click()
        },
        previewImage: function(type) {
            var file
            if (type == "banner") file = document.getElementById("banner").files[0]
            else if (type == "banner-mobile") file = document.getElementById("banner-mobile").files[0]
            else file = document.getElementById("wine-img").files[0]
            var reader = new FileReader()
            reader.onload = function (e) {
                var img = new Image();
                img.src = e.target.result
                if (type == "banner") {
                    document.getElementById('banner-preview').innerHTML = ''
                    document.getElementById('banner-preview').appendChild(img)
                } else if (type == "banner-mobile") {
                    document.getElementById('banner-mobile-preview').innerHTML = ''
                    document.getElementById('banner-mobile-preview').appendChild(img)
                } else {
                    document.getElementById('wine-img-preview').innerHTML = ''
                    document.getElementById('wine-img-preview').appendChild(img)
                }
                
            }
            reader.readAsDataURL(file)            
        },
        uploadBanner: function() {
            const cloudName = 'dkq6zer55';
            const unsignedUploadPreset = 'yrdba4rz';
            var myData = this
            var file = document.getElementById("banner").files[0]
            var url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`
            var xhr = new XMLHttpRequest()
            var fd = new FormData()
            xhr.open('POST', url, false)
            xhr.setRequestHeader('X-Requested-With', "XMLHttpRequest")
            xhr.onreadystatechange = function() {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    var response = JSON.parse(xhr.responseText)
                    var url = response.secure_url
                    myData.currentAd.imageBanner = url
                }
            }
            fd.append('upload_preset', unsignedUploadPreset)
            fd.append('tags', 'blog_image_upload')
            fd.append('file', file)
            xhr.send(fd)
        },
        uploadBannerMobile: function() {
            const cloudName = 'dkq6zer55';
            const unsignedUploadPreset = 'yrdba4rz';
            var myData = this
            var file = document.getElementById("banner-mobile").files[0]
            var url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`
            var xhr = new XMLHttpRequest()
            var fd = new FormData()
            xhr.open('POST', url, false)
            xhr.setRequestHeader('X-Requested-With', "XMLHttpRequest")
            xhr.onreadystatechange = function() {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    var response = JSON.parse(xhr.responseText)
                    var url = response.secure_url
                    myData.currentAd.imageBannerMobile = url
                }
            }
            fd.append('upload_preset', unsignedUploadPreset)
            fd.append('tags', 'blog_image_upload')
            fd.append('file', file)
            xhr.send(fd)
        },
        finalizeAd: function() {
            this.uploadBanner()
            this.uploadBannerMobile()
            this.newAd()
        },
        newAd: function() {
            fb.adsCollection.add({
                name: this.currentAd.name,
                adType: this.currentAd.type,
                startDate: this.currentAd.startDate,
                endDate: this.currentAd.endDate,
                imageBanner: this.currentAd.imageBanner,
                imageBannerMobile: this.currentAd.imageBannerMobile,
                imageCard: this.currentAd.imageCard,
                url: this.currentAd.url,
                clicks: 0,
                page: this.currentAd.page
            })
        },
        displayDate: function(timestamp) {
            if (timestamp) {
                timestamp = new Date(timestamp)
            return moment(timestamp).format('DD/MM/YYYY -  HH:mm')
            } else {
                return "Please select a date"
            }
            
        },
        allFieldsFilled() {
            if (!this.currentAd.name) return false
            if (!this.currentAd.type) return false
            if (!this.currentAd.startDate) return false
            if (!this.currentAd.endDate) return false
            if (!this.currentAd.url) return false
            return true
        },
        handleStartDateClick: function() {
            document.getElementsByClassName("start-date-input")[0].click()
        },
        handleEndDateClick: function() {
            document.getElementsByClassName("end-date-input")[0].click()
        }
    },
    computed: {
        ...mapState(['ads'])
    }
}
</script>

<style>
.new-ad-wrap {
    width: 90%;
    margin:auto;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: white;
    text-align: left;
}
.new-ad-pad {
    padding: 5px;
    width: 100%;
    display: flex;
}
.new-ad-col {
    width: 50%;
    margin-top: 20px;
}
.new-ad-title {
    text-align: center;
}
.new-ad-field-wrap {
    width: 100%;
    text-align: center;
    padding: 10px 0;
}
.new-ad-input {
    width: 80%;
    padding: 10px;
    font-size: 16px;
    border: 3px solid rgb(245, 240, 240);
    resize: none;
    text-align: center;
}
.new-ad-date-button {
    display: inline-block;
}
.new-ad-date-text {
    width: 200px;
    display: inline-block;
}
.new-ad-page-wrap {
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 20px;
}
.new-ad-type-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.new-ad-type-button {
    background-color: #F0F0F0;
    padding: 5px;
    width: 150px;
    text-align: center;
    margin: 5px;
    cursor: pointer;
}
.new-ad-type-active {
    background-color: #b33b3b;
    color: white;
}
.new-ad-image-preview-wrap {
    width: 100%;
}
.new-ad-image-preview {
    background-color: #f0f0f0;
    overflow: hidden;
}
.new-ad-image-preview img {
    width: 100%;
}
.new-ad-image-banner {
    width: 500px;
    height: 61px;
    margin: auto;
}
.new-ad-image-banner-mobile {
    width: 354px;
    height: 98px;
    margin: auto;
}
.new-ad-save-wrap {
    text-align: right;
    height: 80px;
}
.new-ad-save {
    float: right;
    height: 50px;
    width: 150px;
    line-height: 50px;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 20px;
    margin-right: 20px;
}
.new-ad-save-disabled {
    background-color: #f0f0f0;
    color: #9e9e9e;
}
.blue-button {
    background-color: rgb(69, 144, 194);
    color: white;
}
</style>